// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2947":"c3a71a48","4136":"9159ea49"}[chunkId] + ".chunk.css";
};